import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class SlackService {
  sendText({ text }) {
    return ApiService.post(`${Config.api.notification.url}slack`, { text }).then((response) => response.data);
  }
}

const slackService = new SlackService();

export default slackService;
